export const MAP_ADDRESS_SEARCH_EVENT = 'unite:map-address-search';

/** Ask the map search bar to run this address as a GIS search. */
export const requestMapAddressSearch = (address: string): void => {
  const trimmed = address.trim();
  if (!trimmed) return;
  window.dispatchEvent(
    new CustomEvent(MAP_ADDRESS_SEARCH_EVENT, {
      detail: { address: trimmed },
    }),
  );
};
